export const trackRegistrationStart = (): void => {
  if (typeof window === 'undefined' || !window.srtmCommands) return;

  window.srtmCommands.push({
    event: 'track.user.registration',
    payload: { action: 'start' },
  });
};

export const trackRegistrationComplete = (userId: number): void => {
  if (typeof window === 'undefined' || !window.srtmCommands) return;

  window.srtmCommands.push({
    event: 'track.user.registration',
    payload: { action: 'complete', userId },
  });
};
